import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';

export function isUserInKlarnaExperiment(user: Partial<IUser>, acceptedPaymentMethods: string[]) {
  const isKlarnaExperimentEnabled = isExperimentEnabled(user, experiments.CHECKOUT_KLARNA_ACCOUNT);

  return isKlarnaExperimentEnabled &&
    isKlarnaAvailable(acceptedPaymentMethods);
}

export function isKlarnaAvailable(acceptedPaymentMethods: string[]) {
  if (!acceptedPaymentMethods) { return false; }

  return acceptedPaymentMethods.includes('klarna_account');
}

export function filterBuyerPaymentMethods(user: Partial<IUser>, acceptedPaymentMethods?: string[]) {
  if (!acceptedPaymentMethods) { return []; }

  function isPaymentMethodAvailable(paymentMethod: string) {
    if (paymentMethod == 'klarna_account' && !isExperimentEnabled(user, experiments.CHECKOUT_KLARNA_ACCOUNT)) {
      return false;
    }
    return true;
  }

  const filtered = acceptedPaymentMethods.filter(isPaymentMethodAvailable);

  return filtered;
}
